<div [ngClass]="item.is_selected ? 'share-item share-item-selected d-flex flex-column' : 'share-item share-item-normal d-flex flex-column'">
  <div class="checkbox-container" *ngIf="item.state === 'active'">
    <div class="checkbox">
      <app-round-checkbox [extraClass]="'small bg-white'" [id]="item.token" [isSelected]="item.is_selected" (click)="selectByClick()"></app-round-checkbox>
    </div>
  </div>

  <div class="d-flex flex-row mb-2 justify-content-between">
    <span class="text-bolder">{{item.email_subject}}</span>
    <span class="text-normal blue" *ngIf="item.state === 'active'">Expires at {{item.expires_at | date: 'dd.MM.yyyy • HH:mm'}} </span>
    <span class="text-normal red" *ngIf="item.state !== 'active'">Expired</span>
  </div>

  <div class="d-flex flex-row mb-2">
    <span class="text-normal">{{item.files_total }} <span *ngIf="item.files_total===1">file</span><span *ngIf="item.files_total>1">files</span>,  {{item.files_size | fileSize}}</span>
  </div>
  <div class="d-flex flex-row mb-2">
    <span class="text-normal">Send: {{item.date_created | date: 'dd.MM.yyyy • HH:mm'}}</span>
    <div *ngIf="item.was_downloaded" class="d-flex flex-row">
      <img src="./assets/ui/svg/green/icon-check-correct.svg" class="icon">
      <span class="text-normal">Downloaded</span>
    </div>
    <div *ngIf="!item.was_downloaded" class="d-flex flex-row">
      <img src="./assets/ui/svg/grey/exclamation.svg" class="icon">
      <span class="text-normal">Not downloaded</span>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-between">
    <app-see-details [recipients]="item.shared_with" [fileNames]="filenames"></app-see-details>
    <button (click)="revoke()" [ngClass]="item.state === 'active' ? 'revoke-access-btn revoke-access-btn-active' : 'revoke-access-btn revoke-access-btn-inactive'" [disabled]="item.state !== 'active'">Revoke access</button>
  </div>
</div>
